import React, { useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { TranslationsTypes } from '@app/models';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

interface IProps {
    text: TranslationsTypes;
    icon: React.ReactNode;
}

export const Infobox: React.SFC<IProps> = (props) => {
    const { translation } = useTypedTranslation();
    const { text, icon } = props;

    const [closed, isClosed] = useState<boolean>(false);

    return (
        <>
            {!closed &&
                <div className='infobox'>
                    <div className='infobox__icon'>
                        {icon}
                    </div>
                    <div className='infobox__content'>
                        <p>{translation(text)}</p>
                    </div>
                    <div className='infobox__close'>
                        <IconButton
                            id='disableInfobox'
                            size='small'
                            onClick={() => isClosed(true)}
                        >
                            <Close />
                        </IconButton>
                    </div>
                </div>
            }
        </>
    );
};
